module.exports = __webpack_public_path__ + "static/media/SuperiorRoom.4c648d0b.png";